'use strict';

const $ = require('jquery');

function attachEvent(el, ev, cb) {
    // Listen for messages from the player
    if (el.addEventListener){
        el.addEventListener(ev, cb, false);
    } else {
        el.attachEvent("on" + ev, cb, false);
    }
}

function trackEvent(category, action, label) {
    if (window._gaq !== undefined) {
        if (label) {
            window._gaq.push(['_trackEvent', category, action, label]);
        }
        else {
            window._gaq.push(['_trackEvent', category, action]);
        }
    }
    else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'eventForward',
            'eventCategory': category,
            'eventAction': action,
            'eventLabel': label || '',
        });
    }
}

function trackPDFDownload(title) {
    trackEvent('Downloads', 'PDF', title);
}

function trackAudioClick(title) {
    trackEvent('Audio', 'Click', title);
}

function trackAudioPlay(title) {
    trackEvent('Audio', 'Play', title);
}

function trackAudioEnded(title) {
    trackEvent('Audio', 'Ended', title);
}

function trackImageClick(title) {
    trackEvent('Image', 'Click', title);
}

/**
 * Adds Tracking for SoundCloud iFrames
 * @param iframe The HTML iFrame element
 * @param doClick If true then fire a click as well, usable by the Watch &
 *     Listen page
 */
function addSCTracking(iframe, doClick) {
    function apiLoaded() {
        let state;
        let widget = window.SC.Widget(iframe);
        widget.bind(window.SC.Widget.Events.READY, function() {
            if(doClick === true) {
                widget.getCurrentSound(function(data){
                    trackAudioClick(data.user.username + ":" + data.title);
                });
            }
            widget.bind(window.SC.Widget.Events.PLAY, function() {
                // This is to stop firing from when paused, when the FINISH event fires then the trackAudioPlay will fire again
                if(state !== "playing") {
                    widget.getCurrentSound(function(data){
                        trackAudioPlay(data.user.username + ":" + data.title);
                    });
                }
                state = "playing";
            });

            widget.bind(window.SC.Widget.Events.FINISH, function() {
                widget.getCurrentSound(function(data){
                    trackAudioEnded(data.user.username + ":" + data.title);
                });
                state = "ended";
            });
        });
    }

    if(typeof window.SC === "undefined") {
        let tag = document.createElement("script");
        tag.src = "https://w.soundcloud.com/player/api.js";
        attachEvent(tag, "load", apiLoaded);
        let firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
        apiLoaded();
    }
}

function trackLink(ev) {
    let aTag = $(ev.target);
    if(!aTag.attr("href")) {
        return;
    }
    let extLinkTest = new RegExp('[w:]{0,5}//[w.]*' + window.location.host.replace('.', '\\.'));
    let intLinkTest = new RegExp("^/[^/]");
    if(!aTag.attr("href").match(extLinkTest) && !aTag.attr("href").match(intLinkTest) && aTag.attr("href")[0] !== "#") {
        trackEvent("Outbound Links", "Click", aTag.text() + " (" + aTag.attr("href") + ")");
    }
}

function init() {
    // Track External Links
    $("a").on("click", trackLink);

    // Tracking PDF downloads
    $(".content-panel a").click(function() {
        let pdfDownloadHref = $(this).attr("href");
        if(pdfDownloadHref !== undefined) {
            if(pdfDownloadHref.split(".").pop() === "pdf") {
                let pdfTitle = $(this).attr("title");
                trackPDFDownload(pdfTitle);
            }
        }
    });

    // Tracking SoundCloud
    let scFrames = $("iframe[src*=\"w.soundcloud.com/player\"]");
    if(scFrames.length) {
        scFrames.each(function() {
            addSCTracking(this);
        });
    }

    // Track cast images clicks on production page
    $(".cast-creative__person img").on("click", function() {
        trackImageClick(this.alt);
    });
}

module.exports = {
    init: init
}
